export default {
  ws: {},
  subIds:[],
  getSub: function(){
    return this.subIds.join(",")
  },
  setWs: function(newWs) {
    this.ws = newWs
  },
  connectState: false,
  reconnectTimes: [1,2,4,16,32,64]
}

